import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import '@/style/style.less'
import request from '@/utils/request'
import request_n from '@/utils/request_n'
import request_new from '@/utils/request_new'
import request_xf from '@/utils/request_xf'
import request_again from '@/utils/request_again'
import request_yx from '@/utils/request_yx'

import main from '@/utils/public'
import lazy_img from '@/assets/img/default_house_list.jpg'
import logo_img from '@/assets/img/xflogo.png'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import BaiduMap from 'vue-baidu-map-v3'
import { wxshare } from '@/common'
import { checkFollow } from '@/common'


Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(Lazyload, {
    loading: lazy_img,
    error: lazy_img
});
Vue.use(VueAwesomeSwiper)
Vue.use(BaiduMap, {
    // 9g2x6BUSyTlhf9BZWoGsRb5VQdBaRYGh
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'upHCLxxSlAX8R2j0EPRwct86DxrVwyZH'
})
Vue.prototype.$http = request
Vue.prototype.$new = request_n
Vue.prototype.$request = request_new
Vue.prototype.$request_xf = request_xf
Vue.prototype.$request_again = request_again
Vue.prototype.$request_yx = request_yx
Vue.prototype.main = main
Vue.prototype.kefuPath = 'https://xf.xzhouse.com.cn/api/sys/common/static/'
Vue.prototype.imgPath = 'https://www.xzhouse.com.cn/house/xzh_static/'
Vue.prototype.$share = wxshare
Vue.prototype.$checkFollow = checkFollow

Vue.prototype.logoImg = logo_img
Vue.config.ignoredElements = ['wx-open-launch-weapp']


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");